import React from "react";
import { Typography } from "@mui/material";
import { getSlidingGroupPublishedAt } from "../../../../pages/browse-sliding/slidingBrowseUtils";
import { usePagesTranslation } from "../../../../pages/locales";
import UtilService from "../../../../services/UtilService";
import { useSlidingAppearance } from "../lib/AppearanceContext";

const systemFont =
    '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif';

/**
 * "Published 2 days ago" under puzzle previews (home + library).
 */
export default function PuzzlePublishedAtLine({ group = null, publishedAt = null, sx = {} }) {
    const { t, lang } = usePagesTranslation();
    const { tokens } = useSlidingAppearance();
    const raw =
        publishedAt != null && String(publishedAt).trim() !== ""
            ? publishedAt
            : getSlidingGroupPublishedAt(group);
    if (raw == null || String(raw).trim() === "") {
        return null;
    }
    const pubMs = new Date(raw).getTime();
    if (!Number.isFinite(pubMs) || pubMs <= 0) {
        return null;
    }
    const publishedAgo = UtilService.formatHumanizeDetailed(Math.abs(Date.now() - pubMs), lang);
    if (!publishedAgo) {
        return null;
    }

    return (
        <Typography
            component="p"
            sx={{
                fontFamily: systemFont,
                fontSize: "0.8125rem",
                lineHeight: 1.35,
                color: tokens.textMuted,
                mb: 0.75,
                ...sx,
            }}
        >
            {t("puzzle.card.published", { defaultValue: "Published" })}: {publishedAgo}
        </Typography>
    );
}
